import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const serviceLinks = [
  { to: "/services", label: "Todos los servicios" },
  { to: "/services/consultation", label: "Consultas" },
  { to: "/services/laboratory", label: "Laboratorio" },
  { to: "/services/surgery", label: "Cirugías" },
  { to: "/services/cataractSurgery", label: "Cirugía de cataratas" },
  { to: "/services/insemination", label: "Inseminación artificial" },
  { to: "/services/FCM", label: "Pedigrí y trámites FCM" },
];

export const MainPagesNavbar = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isServicesOpen = Boolean(anchorEl);

  const handleOpenServices = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseServices = () => setAnchorEl(null);
  const goTo = (to: string) => {
    handleCloseServices();
    navigate(to);
  };

  return (
    <nav className="l-navbar navbar navbar-dark navbar-expand-md fixed-top u-bgPrimaryLighter">
      <div className="container-fluid">
        <Link to="/">
          <img
            className="l-navbar_logo"
            src="assets/imgs/Logo_HVP.png"
            alt="Hospital Veterinario Peninsular"
          />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <ul className="l-navbar_menu navbar-nav me-auto mb-md-0 text-white">
            <li className="nav-item l-navbar_item">
              <NavLink
                className={({ isActive }) =>
                  `nav-item nav-link ${isActive ? "active" : ""}`
                }
                to="/"
              >
                Inicio
              </NavLink>
            </li>
            <li className="nav-item l-navbar_item">
              <NavLink
                className={({ isActive }) =>
                  `nav-item nav-link ${isActive ? "active" : ""}`
                }
                to="/advices"
              >
                Blog y consejos
              </NavLink>
            </li>
            <li className="nav-item l-navbar_item">
              <button
                type="button"
                className="nav-item nav-link"
                onClick={handleOpenServices}
                aria-haspopup="true"
                aria-expanded={isServicesOpen}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "2px",
                  font: "inherit",
                }}
              >
                Servicios
                <KeyboardArrowDownIcon style={{ fontSize: "2rem" }} />
              </button>
              <Menu
                anchorEl={anchorEl}
                open={isServicesOpen}
                onClose={handleCloseServices}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                slotProps={{ paper: { sx: { mt: 1, minWidth: 220 } } }}
              >
                {serviceLinks.map((service) => (
                  <MenuItem
                    key={service.to}
                    onClick={() => goTo(service.to)}
                    sx={{ fontSize: "1.5rem", py: 1.2 }}
                  >
                    {service.label}
                  </MenuItem>
                ))}
              </Menu>
            </li>
            <li className="nav-item l-navbar_item">
              <NavLink
                className={({ isActive }) =>
                  `nav-item nav-link ${isActive ? "active" : ""}`
                }
                to="/team"
              >
                Equipo
              </NavLink>
            </li>
            <li className="nav-item l-navbar_item">
              <NavLink
                className={({ isActive }) =>
                  `nav-item nav-link ${isActive ? "active" : ""}`
                }
                to="/company"
              >
                Empresa
              </NavLink>
            </li>
            <li className="nav-item l-navbar_item">
              <NavLink
                className={({ isActive }) =>
                  `nav-item nav-link ${isActive ? "active" : ""}`
                }
                to="/contact"
              >
                Contacto
              </NavLink>
            </li>
            <li className="nav-item l-navbar_item">
              <NavLink
                className={({ isActive }) =>
                  `nav-item nav-link ${isActive ? "active" : ""}`
                }
                to="/facturacion/login"
              >
                Facturación
              </NavLink>
            </li>
            <li className="nav-item l-navbar_item">
              <NavLink
                className={({ isActive }) =>
                  `nav-item nav-link ${isActive ? "active" : ""}`
                }
                to="/auth"
              >
                Acceso
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
